import AnimateOnScroll from "@/components/AnimateOnScroll";
import * as StyledLayout from "../Styled.Layout";
import Hero from "@/components/Header/Hero";
import EmailSignup from "@/components/EmailSignup";

export default function ArticleArchiveLayout({ children, heroProps }) {
  return (
    <StyledLayout.PageLayoutWrapper>
      <Hero {...heroProps} />
      <AnimateOnScroll>
        {children}
        <StyledLayout.Grid>
          <StyledLayout.GridItem data-animate="fade-up">
            <EmailSignup />
          </StyledLayout.GridItem>
        </StyledLayout.Grid>
      </AnimateOnScroll>
    </StyledLayout.PageLayoutWrapper>
  );
}
